<template>
  <div class="monitoring__item" @click="emitEvent">
    <label v-if="source.showLocation === true" class="monitoring__item_header"><strong> {{ source.showLocation === true ? `${source.location_name}` : '' }}</strong></label>
    <label class="monitoring__item_header"> <strong> {{ getDate }}</strong> <v-icon v-if="source.selected" style="color: #22c55e; position: absolute; right: 1rem;">check_circle</v-icon> </label>
    <div class="monitoring__item_content">
      <div :class="[{'monitoring__item_content--red': source.camera1.event_type === 'UNKNOWN FACE'|| source.camera1.event_type === 'INVALID FACE PICTURE COMPARISON'}, {'monitoring__item_content--green': source.camera1.event_type !== 'UNKNOWN FACE' && source.camera1.event_type !== 'INVALID FACE PICTURE COMPARISON'}]">
        <img class="monitoring__item_camera" alt="event" :src="source.camera1.photo ?? source.camera1.photo_url">
        <img class="monitoring__cropped" v-if="source.showCroppedPhoto" :src="source.camera1.cropped_photo">
        <span></span>
      </div>
      <div :class="[{'monitoring__item_content--red': source.camera2.event_type === 'UNKNOWN FACE'|| source.camera2.event_type === 'INVALID FACE PICTURE COMPARISON'}, {'monitoring__item_content--green': source.camera2.event_type !== 'UNKNOWN FACE' && source.camera2.event_type !== 'INVALID FACE PICTURE COMPARISON'}]">
        <img class="monitoring__item_camera" alt="event" :src="source.camera2.photo ?? source.camera2.photo_url">
        <img class="monitoring__cropped" v-if="source.showCroppedPhoto" :src="source.camera1.cropped_photo">
        <span></span>
      </div>
    </div>
  </div>
</template>
<script>
import itemClickEventBus from '../../../services/eventBus';


export default {
  name: 'EventItem',
  props: {
    source: {
      type: Object,
      default: () => ({id: 1, name: 'name'}),
    }
  },
  computed: {
    getDate() {
      const date = new Date(this.source.event_time);
      const day = String(date.getDate()).padStart(2, 0);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      const ampm = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      hours = hours ? hours : 12;
      const formatedHours = String(hours).padStart(2, '0');

      return `${day}/${month}/${year} - ${formatedHours}:${minutes}:${seconds} ${ampm}`;
    }
  },
  methods: {
    emitEvent() {
      if (this.source.emitEvent === true) {
        itemClickEventBus.$emit('item_click', this.source);
      }
    }
  },

}
</script>

